export default "__VITE_ASSET__IolCAm0k__"